exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crearProveedor #alinear[data-v-61ef292c] {\n  text-align: justify;\n}\n.crearProveedor .h2_title[data-v-61ef292c] {\n  font-weight: normal;\n}\n", ""]);

// exports
